export function validarNome(nomeStr) {
  // const nome = nomeStr.replace(/[^a-zA-ZáéíóúàèìòùâêîôûãõçÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÃÕÇ\s]/g, '');
  const words = nomeStr.split(' ');

  return (words.length >= 2 && words[0].length > 2);
  // return nomeStr.match(/[A-z][ ][A-z]/);
}
